import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.css';

const sections = [
  {
    key: 'survey',
    icon: '📄',
    label: 'Survey',
    links: [
      { to: '/surveys/upload', label: 'Upload Survey' },
      { to: '/surveys/manage-surveys', label: 'Manage Surveys' },
      { to: '/surveys/manage-startups', label: 'Manage Startups' },
    ],
  },
  {
    key: 'video',
    icon: '🎞️',
    label: 'Video',
    links: [
      {
        to: '/video/analysis/upload-videos',
        label: 'Upload Videos',
        end: true,
      },
      {
        to: '/video/analysis/download',
        label: 'Download Analysis',
        end: true,
      },
      {
        to: '/video/analysis/upload-analysis',
        label: 'Upload Analysis',
        end: true,
      },
    ],
  },
];

const Sidebar = () => {
  const [expandedSections, setExpandedSections] = useState({
    survey: true,
    video: true,
  });
  const [collapsed, setCollapsed] = useState(false);

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const toggleSidebar = () => setCollapsed((prev) => !prev);

  // New: handle click on icon in collapsed mode
  const handleSectionIconClick = (sectionKey) => {
    if (collapsed) {
      setCollapsed(false);
      setTimeout(() => {
        setExpandedSections((prev) => ({
          ...prev,
          [sectionKey]: true,
        }));
      }, 250); // Wait for animation
    } else {
      toggleSection(sectionKey);
    }
  };

  return (
    <nav
      className={`${styles.sidebar} ${collapsed ? styles.sidebarCollapsed : ''}`}
      aria-label="Sidebar"
    >
      <button
        className={styles.collapseBtn}
        onClick={toggleSidebar}
        aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        type="button"
        tabIndex={0}
      >
        <span className={styles.collapseIcon}>{collapsed ? '»' : '«'}</span>
      </button>
      <div className={styles.sections}>
        {sections.map((section) => (
          <div className={styles.section} key={section.key}>
            <div
              className={`${styles.sectionTitle} ${!expandedSections[section.key] ? styles.collapsed : ''}`}
              onClick={() =>
                collapsed
                  ? handleSectionIconClick(section.key)
                  : toggleSection(section.key)
              }
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  collapsed
                    ? handleSectionIconClick(section.key)
                    : toggleSection(section.key);
                }
              }}
              title={collapsed ? section.label : undefined}
            >
              <span className={styles.sectionIcon}>{section.icon}</span>
              {!collapsed && <span>{section.label}</span>}
              {!collapsed && (
                <span className={styles.arrow} aria-hidden>
                  {expandedSections[section.key] ? '▾' : '◂'}
                </span>
              )}
            </div>
            {!collapsed && expandedSections[section.key] && (
              <div className={styles.links}>
                {section.links.map((link) => (
                  <NavLink
                    key={link.to}
                    to={link.to}
                    end={link.end}
                    className={({ isActive }) =>
                      isActive ? styles.activeLink : styles.link
                    }
                  >
                    {link.label}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </nav>
  );
};

export default Sidebar;
